export default {
	methods: {
		showSearchPackModal(searchPack) {
			this.$vmodal.open({
				component: require("../apps/portal/views/client/instruction/modals/SearchPack.vue").default,
				props: {
					searchPack: searchPack,
				},
			});
		},
	},
};
